import { enUS, frFR } from "@mui/material/locale";
import { Direction } from "@mui/material";

const DEFAULT_LANGUAGE = "en";
const PRIORITY_LANGUAGES = ["en", "fr"];

// languages that can be displayed on the site
const priorityLanguageMap = {
  en: {
    label: "English",
    dir: "ltr" as Direction,
    mui: enUS,
    value: "English",
    locale: "en",
  },
  fr: {
    label: "French",
    dir: "ltr" as Direction,
    mui: frFR,
    value: "French",
    locale: "fr",
  },
};

// languages that can be displayed on the exams
const allLanguageMap = {
  // priority languages (english, french)
  ...priorityLanguageMap,

  // all other languages (in alphabetical order)
  af: {
    label: "Afrikaans",
    dir: "ltr",
    value: "Afrikaans",
  },
  alb: {
    label: "Albanian",
    dir: "ltr",
    value: "Albanian",
  },
  ar: {
    label: "Arabic",
    dir: "rtl",
    value: "Arabic",
  },
  bn: {
    label: "Bengali",
    dir: "ltr",
    value: "Bengali",
  },
  yue: {
    label: "Cantonese",
    dir: "ltr",
    value: "Cantonese",
  },
  hr: {
    label: "Croatian",
    dir: "ltr",
    value: "Croatian",
  },
  prs: {
    label: "Dari",
    dir: "rtl",
    value: "Dari",
  },
  de: {
    label: "German",
    dir: "ltr",
    value: "German",
  },
  el: {
    label: "Greek",
    dir: "ltr",
    value: "Greek",
  },
  gu: {
    label: "Gujarati",
    dir: "ltr",
    value: "Gujarati",
  },
  he: {
    label: "Hebrew",
    dir: "rtl",
    value: "Hebrew",
  },
  hi: {
    label: "Hindi",
    dir: "ltr",
    value: "Hindi",
  },
  it: {
    label: "Italian",
    dir: "ltr",
    value: "Italian",
  },
  ja: {
    label: "Japanese",
    dir: "ltr",
    value: "Japanese",
  },
  ko: {
    label: "Korean",
    dir: "ltr",
    value: "Korean",
  },
  cmn: {
    label: "Mandarin",
    dir: "ltr",
    value: "Mandarin",
  },
  fa: {
    label: "Persian",
    dir: "rtl",
    value: "Persian",
  },
  pl: {
    label: "Polish",
    dir: "ltr",
    value: "Polish",
  },
  pt: {
    label: "Portuguese",
    dir: "ltr",
    value: "Portuguese",
  },
  pa: {
    label: "Punjabi",
    dir: "ltr",
    value: "Punjabi",
  },
  kek: {
    label: "Q'eqchi'",
    dir: "ltr",
    value: "Q'eqchi'",
  },
  ro: {
    label: "Romanian",
    dir: "ltr",
    value: "Romanian",
  },
  ru: {
    label: "Russian",
    dir: "ltr",
    value: "Russian",
  },
  sr: {
    label: "Serbian",
    dir: "ltr",
    value: "Serbian",
  },
  so: {
    label: "Somali",
    dir: "ltr",
    value: "Somali",
  },
  es: {
    label: "Spanish",
    dir: "ltr",
    value: "Spanish",
  },
  sw: {
    label: "Swahili",
    dir: "ltr",
    value: "Swahili",
  },
  tl: {
    label: "Tagalog",
    dir: "ltr",
    value: "Tagalog",
  },
  ta: {
    label: "Tamil",
    dir: "ltr",
    value: "Tamil",
  },
  ti: {
    label: "Tigrinya",
    dir: "ltr",
    value: "Tigrinya",
  },
  tr: {
    label: "Turkish",
    dir: "ltr",
    value: "Turkish",
  },
  uk: {
    label: "Ukrainian",
    dir: "ltr",
    value: "Ukrainian",
  },
  ur: {
    label: "Urdu",
    dir: "rtl",
    value: "Urdu",
  },
  vi: {
    label: "Vietnamese",
    dir: "ltr",
    value: "Vietnamese",
  },
  zu: {
    label: "Zulu",
    dir: "ltr",
    value: "Zulu",
  },
};

export {
  DEFAULT_LANGUAGE,
  PRIORITY_LANGUAGES,
  priorityLanguageMap,
  allLanguageMap,
};
